var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"is-vertical"},[_c('AppHeader'),_c('UpdatePassword'),_c('el-container',[_c('AppSidebar'),_c('el-main',{class:_vm.bgClass,staticStyle:{"overflow-x":"hidden"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }